<script setup>
import { computed } from 'vue';
import { useI18n } from 'vue-i18n';
import KanbanFilterOperatorSelect from './KanbanFilterOperatorSelect.vue';

const props = defineProps({
  modelValue: { type: Array, default: () => [] },
});

const emit = defineEmits(['update:modelValue']);

const { t } = useI18n();

const unitOptions = computed(() => [
  { value: 'days', label: t('FLOWS.FILTER.DATE_UNITS.DAYS') },
  { value: 'weeks', label: t('FLOWS.FILTER.DATE_UNITS.WEEKS') },
  { value: 'months', label: t('FLOWS.FILTER.DATE_UNITS.MONTHS') },
  { value: 'years', label: t('FLOWS.FILTER.DATE_UNITS.YEARS') },
]);

const current = computed(() => {
  if (props.modelValue.length && typeof props.modelValue[0] === 'object') {
    return props.modelValue[0];
  }
  return { count: '', unit: 'days' };
});

function onCountChange(e) {
  const count = Number(e.target.value);
  emit('update:modelValue', [{ count, unit: current.value.unit }]);
}

function onUnitChange(unit) {
  emit('update:modelValue', [{ count: current.value.count, unit }]);
}
</script>

<template>
  <div class="flex gap-2 items-center">
    <input
      type="number"
      min="1"
      :value="current.count"
      class="!h-8 !m-0 w-20 border border-n-weak rounded-lg px-3 text-sm bg-n-background text-n-slate-12 focus:outline-none focus:border-n-brand"
      @input="onCountChange"
    />
    <div class="w-32">
      <KanbanFilterOperatorSelect
        :model-value="current.unit"
        :options="unitOptions"
        @update:model-value="onUnitChange"
      />
    </div>
  </div>
</template>
